import React from 'react';

interface CalendarIconProps {
  size?: number;
  color?: string;
}

export const CalendarIcon: React.FC<CalendarIconProps> = ({ 
  size = 24, 
  color = '#000000' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 24 24"
    >
      <path 
        fill={color} 
        d="M6.516 2.25a.61.61 0 0 1 .609.61v.609h9.75v-.61a.61.61 0 1 1 1.219 0v.61h1.218a2.437 2.437 0 0 1 2.438 2.437v13.407a2.44 2.44 0 0 1-2.437 2.437H4.688a2.44 2.44 0 0 1-2.438-2.437V8.343h19.5V7.126H2.25V5.906A2.437 2.437 0 0 1 4.688 3.47h1.218v-.61a.61.61 0 0 1 .61-.609"
      />
    </svg>
  );
};

